import { StyleSheet, Platform, StatusBar, Dimensions } from 'react-native';
import { COLORS } from '../../constants/theme';

const { width } = Dimensions.get('window');

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fafafa',
  },
  header: {
    backgroundColor: '#1F2937',
    paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight || 0 : 130,
    paddingBottom: 120,
    borderBottomLeftRadius: 18,
    borderBottomRightRadius: 18,
    overflow: 'hidden',
  },
  headerTablet: {
    backgroundColor: 'transparent',
    paddingTop: 0,
    paddingBottom: 16,
  },
  greetingTablet: {
    fontSize: 28,
    fontWeight: '700',
    color: '#1F2937',
    marginBottom: 4,
    fontFamily: 'Montserrat_700Bold',
  },
  welcomeTextTablet: {
    fontSize: 16,
    color: '#6B7280',
    fontFamily: 'Montserrat_400Regular',
  },
  content: {
    flex: 1,
    paddingHorizontal: width >= 1600 ? 32 : width >= 1280 ? 24 : 16,
    paddingTop: 20,
    paddingBottom: 100,
    zIndex: 1,
  },
  tabletContent: {
    alignSelf: 'center',
    width: '100%',
    maxWidth: 920,
    paddingHorizontal: 24,
  },
  content320: {
    paddingHorizontal: 10,
    paddingTop: 10,
  },
  gridRow: {
    flexDirection: 'row',
    gap: 24,
  },
  gridCol: {
    flex: 1,
  },
  desktopLayoutVertical: {
    flexDirection: 'column',
    gap: 20,
    width: '100%',
  },
  issuerRankingRow: {
    flexDirection: 'row',
    gap: width >= 1280 ? 20 : 16,
    width: '100%',
  },
  issuerRankingColumn: {
    flexDirection: 'column',
    gap: width >= 1280 ? 20 : 16,
    width: '100%',
  },
  issuerCard: {
    flex: 1,
    minWidth: 0,
  },
  twoWidgetsRow: {
    flexDirection: 'row',
    gap: width >= 1280 ? 20 : 16,
    width: '100%',
  },
  oneWidgetColumn: {
    flexDirection: 'column',
    gap: width >= 1280 ? 20 : 16,
    width: '100%',
  },
  widgetCardHalf: {
    flex: 1,
    minWidth: 0,
  },
  checkboxRowDesktop: {
    paddingHorizontal: 20,
    marginTop: -10,
  },
  tabletTwoColumns: {
    flexDirection: 'row',
    gap: 20,
    width: '100%',
  },
  tabletHalfColumn: {
    flex: 1,
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#F4F4F4',
    padding: width >= 1600 ? 24 : width >= 1280 ? 20 : 16,
    marginBottom: width >= 1280 ? 20 : 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 2,
  },
  calendarCard: {
    padding: 12,
  },
  notificationsCard: {
    padding: 0,
    overflow: 'hidden',
  },
  card320: {
    padding: 10,
  },
  cardMd: {
    padding: 15,
  },
  firstCard: {
    marginTop: -150,
    elevation: 6,
  },
  firstCardTablet: {
    marginTop: 0,
    zIndex: 3,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  sectionHeaderCustom: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  sectionTitleCustom: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#222',
    fontFamily: 'Montserrat_700Bold',
  },
  arrowButton: {
    width: 44,
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
  },
  arrowText: {
    fontSize: 28,
    color: '#374151',
    fontWeight: '500',
    fontFamily: 'Montserrat_500Medium',
    textAlign: 'center',
    lineHeight: 28,
  },
  toggleRowCustom: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  toggleContainerCustom: {
    flexDirection: 'row',
    backgroundColor: 'transparent',
    borderRadius: 20,
    padding: 4,
    alignSelf: 'flex-start',
  },
  toggleButtonCustom: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 18,
    borderRadius: 16,
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    shadowColor: 'transparent',
    elevation: 0,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  toggleButtonActiveCustom: {
    backgroundColor: 'rgba(0,80,110,0.10)',
    shadowColor: 'transparent',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0,
    shadowRadius: 0,
    elevation: 0,
    borderColor: '#BFD4DC',
  },
  toggleInnerRightSquare: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRightWidth: 0,
  },
  toggleInnerLeftSquare: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeftWidth: 0,
  },
  toggleTextCustom: {
    fontSize: 14,
    fontWeight: '600',
    fontFamily: 'Montserrat_600SemiBold',
  },
  toggleTextActiveCustom: {
    color: '#111827',
  },
  toggleTextInactiveCustom: {
    color: '#9CA3AF',
  },
  pieAndLegendRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
  },
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
  },
  checkbox: {
    width: 18,
    height: 18,
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  checkboxChecked: {
    backgroundColor: '#FFFFFF',
    borderColor: COLORS.primary,
  },
  checkmark: {
    color: COLORS.primary,
    fontSize: 11,
    fontWeight: 'bold',
    fontFamily: 'Montserrat_700Bold',
  },
  checkboxLabel: {
    fontSize: 14,
    color: '#374151',
    fontFamily: 'Montserrat_400Regular',
  },
  headerContentCustomRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingTop: 32,
    paddingBottom: 24,
  },
  greetingCustom: {
    color: '#fff',
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 2,
    fontFamily: 'Montserrat_700Bold',
  },
  welcomeTextCustom: {
    color: '#E0F2F7',
    fontSize: 15,
    fontWeight: '400',
    fontFamily: 'Montserrat_400Regular',
  },
  logoutButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: COLORS.primary,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 2,
    elevation: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoutIcon: {
    fontSize: 22,
    color: COLORS.primary,
    fontFamily: 'Montserrat_400Regular',
  },
  scrollContainer: {
    flex: 1,
    marginTop: -120,
  },
  scrollContainerTablet: {
    marginTop: 0,
  },
  scrollContent: {
    flexGrow: 1,
    paddingTop: 120,
    paddingBottom: 20,
  },
  scrollContentTablet: {
    paddingTop: 60,
    paddingBottom: 20,
  },
  // Modal styles
  modalOverlay: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  },
  modalBackdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  modalContent: {
    backgroundColor: '#FFFFFF',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '90%',
    minHeight: '60%',
    elevation: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: 1001,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1F2937',
    fontFamily: 'Montserrat_600SemiBold',
  },
  closeButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F3F4F6',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButtonText: {
    fontSize: 16,
    color: '#6B7280',
    fontWeight: '600',
    fontFamily: 'Montserrat_600SemiBold',
  },
  modalTabsContainer: {
    flexDirection: 'row',
    marginHorizontal: 20,
    marginVertical: 16,
    backgroundColor: '#F3F4F6',
    borderRadius: 8,
    padding: 4,
  },
  modalTab: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 6,
    alignItems: 'center',
  },
  modalActiveTab: {
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  modalTabText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#6B7280',
    fontFamily: 'Montserrat_500Medium',
  },
  modalActiveTabText: {
    color: '#1F2937',
    fontWeight: '600',
    fontFamily: 'Montserrat_600SemiBold',
  },
  modalScrollView: {
    flex: 1,
    paddingHorizontal: 20,
  },
  modalLoadingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 40,
  },
  modalLoadingText: {
    marginLeft: 8,
    fontSize: 14,
    color: '#6B7280',
    fontFamily: 'Montserrat_400Regular',
  },
  modalEmptyState: {
    alignItems: 'center',
    paddingVertical: 40,
  },
  modalEmptyStateText: {
    fontSize: 14,
    color: '#6B7280',
    fontStyle: 'italic',
    fontFamily: 'Montserrat_400Regular',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#F3F4F6',
    borderRadius: 8,
    paddingVertical: 6,
    paddingHorizontal: 8,
    marginBottom: 10,
    alignItems: 'center',
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8,
    marginBottom: 6,
    paddingVertical: 8,
    paddingHorizontal: 8,
    shadowColor: '#000',
    shadowOpacity: 0.03,
    shadowRadius: 1,
    elevation: 1,
  },
  tableCell: {
    width: 70,
    textAlign: 'center',
    fontWeight: 'bold',
    color: COLORS.primary,
  },
  tableCellCenter: {
    width: 130,
    textAlign: 'center',
    color: '#222',
    fontWeight: '600',
  },
  tableCellFlex: {
    flex: 1,
    color: '#444',
    textAlign: 'center',
  },
  headerCell: {
    width: 70,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerCellCenter: {
    width: 130,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerCellFlex: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerText: {
    textAlign: 'center',
    color: '#6B7280',
    fontWeight: 'bold',
  },
  modalCheckboxContainer: {
    paddingTop: 20,
    alignItems: 'flex-start',
  },
  modalCheckboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
  },
  modalCheckbox: {
    width: 20,
    height: 20,
    borderWidth: 2,
    borderColor: '#D1D5DB',
    borderRadius: 4,
    marginRight: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalCheckboxChecked: {
    backgroundColor: COLORS.primary,
    borderColor: COLORS.primary,
  },
  modalCheckmark: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: 'bold',
  },
  modalCheckboxLabel: {
    fontSize: 14,
    color: '#374151',
    fontFamily: 'Montserrat_400Regular',
  },
});
